export default __webpack_public_path__ + "static/media/title logo.559b0db4.png";